module.exports = __webpack_public_path__ + "images/a5a3730f23f34ebfd59ecf7bc0af40db-logo.png";